import React from "react"

const RyderLivescoringHolesDefaultView = ({
    holes,
    team1Id,
    team2Id,
    teamColors,
    hasDateToShow,
    matchDate,
    matchHour
}) => {
    return (
        <>
            <div className="hidden sm:flex w-full border-t border-gray-300 bg-white justify-between items-center py-2 px-4">
                <div className="flex space-x-1">
                    {holes.map((h, idx) => {
                        let value = h[1]
                        const n = h[0]
                        let bg = "bg-gray-100 text-gray-400 transition-colors"

                        if (value === team1Id) bg = `hole-winner-${teamColors[team1Id]}`
                        if (value === team2Id) bg = `hole-winner-${teamColors[team2Id]}`
                        if (value === 'tie') bg = `hole-winner-tie`

                        return (
                            <div
                                key={n}
                                className={`w-6 h-6 mr-2 sm:w-4 sm:h-4 md:w-5 md:h-5 xl:w-8 xl:h-8 text-xs xl:text-sm 2xl:w-10 2xl:h-10 2xl:text-base rounded-full flex items-center justify-center transition-colors duration-500 ease-in-out ${bg}`}
                            >
                                {n}
                            </div>
                        )
                    })}
                </div>

                {hasDateToShow && (
                    <div className="flex items-center space-x-2">
                        {matchDate && (
                            <span className="text-xs sm:text-xs lg:text-base font-medium text-gray-400 date-style bg-gray-100 rounded-md px-2 py-1">
                                {matchDate}
                            </span>
                        )}
                        {matchHour && (
                            <span className="text-xs sm:text-xs lg:text-base font-medium text-gray-700 hour-style bg-blue-100 rounded-full px-2 py-1">
                                {matchHour}
                            </span>
                        )}
                    </div>
                )}
            </div>

            <div className="sm:hidden px-4 py-2 border-t border-gray-300">
                <div className="grid grid-cols-9 gap-1">
                    {holes.map((h, idx) => {
                        const n = h[0]
                        let value = h[1]
                        let bg = "bg-gray-100 text-gray-400 transition-colors"

                        if (value === team1Id) bg = `hole-winner-${teamColors[team1Id]}`
                        if (value === team2Id) bg = `hole-winner-${teamColors[team2Id]}`
                        if (value === 'tie') bg = `hole-winner-tie`

                        return (
                            <div
                                key={n}
                                className={`w-6 h-6 rounded-full flex items-center justify-center text-xs transition-colors duration-500 ease-in-out ${bg}`}
                            >
                                {n}
                            </div>
                        )
                    })}
                </div>
            </div>
        </>
    )
}

export default RyderLivescoringHolesDefaultView
